import React from 'react';

interface Props {
  children: React.ReactNode;
}

export function Container({ children }: Props): JSX.Element {
  return <div className="container">{children}</div>;
}
